import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getPlanosFinanceiros(context, dados) {
        if((!dados.pagina) || (!dados.quantidadePorPagina)) {
            dados.pagina = 1;
            dados.quantidadePorPagina = 25;
        }
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("planosFinanceiros/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getPlanosFinanceirosTodos(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("planosFinanceiros/access/listar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getPlanosFinanceirosPorNivel(context, $codigoSuperior) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("planosFinanceiros/access/listarPorNivel", {CODIGO_PLANO_FINANCEIRO_SUPERIOR: $codigoSuperior}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },    
    getPlanosFinanceirosBox(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("planosFinanceiros/access/listaBox", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPlanoFinanceiro(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("planosFinanceiros/access/obter", {ID_PLANO_FINANCEIRO: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    getPlanoFinanceiroSimples(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("planosFinanceiros/access/obterSimples", {ID_PLANO_FINANCEIRO: id}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    deletePlanoFinanceiro(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("planosFinanceiros/access/excluir", {ID_PLANO_FINANCEIRO: dados.id, componente: dados.componente}).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    },
    postPlanoFinanceiro(context, dados) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("planosFinanceiros/access/salvar", dados).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    getPlanosUsuarios(context, id) {
        return new Promise(resolve => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("planosFinanceiros/access/obterUsuarios", id).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }

};

export default {
    state,
    actions,
    mutations,
    getters
};